//axios api
import api from "@/lib/Api";
import moment from "moment";
export const getAreaAndDistrict = async () => {
  try {
    const queryRoute = "/statistics/getAreaAndDistrict";
    const fetchRes = api.axios.post(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getProducts = async () => {
  try {
    const queryRoute = "/statistics/getProducts";
    const fetchRes = api.axios.post(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const exportShopReport = async (year, compareYear, selectedProduct) => {
  try {
    const queryRoute = `/statistics/shopSales/export?year=${moment(year).format("YYYY")}&compareYear=${moment(compareYear).format("YYYY")}&product_ids=${selectedProduct.join(",")}`;
    const fetchRes = api.axios.get(queryRoute, {
      responseType: "blob",
    });
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const getProfitAndLoss = async (
  product_ids,
  start_date,
  end_date,
  combineSameSku,
  groupBy = "brand",
) => {
  try {
    const queryRoute = `/statistics/profitAndLoss?product_ids=${product_ids.join(
      ",",
    )}&start_date=${start_date}&end_date=${end_date}&combineSameSku=${
      combineSameSku ? 1 : 0
    }&groupBy=${groupBy}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getProductSales = async (filter, manningsData) => {
  try {
    const queryRoute = "/statistics/getProductSales";
    const queryBody = {
      filter,
      manningsData,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getShopSales = async (filter, manningsData) => {
  try {
    const queryRoute = `/statistics/getShopSales`;
    const queryBody = {
      filter,
      manningsData,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getSummaryByProduct = async (product_ids, date) => {
  try {
    const queryRoute = `/statistics/summary/product?product_ids=${product_ids.join(
      ",",
    )}&date=${date}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getSummaryByBrand = async (date) => {
  try {
    const queryRoute = `/statistics/summary/brand?date=${date}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getMaxDate = async () => {
  try {
    const queryRoute = `/statistics/summary/maxDate`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getShopSalesWithTarget = async (
  filter,
  orderBy,
  order,
  limit,
  manningsData,
) => {
  try {
    const queryRoute = "/statistics/getShopSalesWithTarget";
    const queryBody = {
      filter,
      orderBy,
      order,
      limit,
      manningsData,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getProductTrend = async (filter, manningsData) => {
  try {
    const queryRoute = "/statistics/getProductTrend";
    const queryBody = {
      filter,
      manningsData,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getProductDisscountPerformance = async (filter) => {
  try {
    const queryRoute = "/statistics/getProductDisscountPerformance";
    const queryBody = {
      filter,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getMonthlyDiscount = async (filter) => {
  try {
    const queryRoute = "/statistics/getMonthlyDiscount";
    const queryBody = {
      filter,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getShopSalesByAreaMan = async (filter, manningsData) => {
  try {
    const queryRoute = "/statistics/getShopSalesByAreaMan";
    const queryBody = {
      filter,
      manningsData,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getProductSalesByShopCode = async (
  shopName,
  start_date,
  end_date,
  manningsData,
) => {
  try {
    const queryRoute = "/statistics/getProductSalesByShopCode";
    const queryBody = {
      shopName,
      start_date,
      end_date,
      manningsData,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getShopSalesByMonth = async (shopCode, month, manningsData) => {
  try {
    const queryRoute = "/statistics/getShopSalesByMonth";
    const queryBody = {
      shopCode,
      month,
      manningsData,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const compareSales = async (
  brand_id,
  product_master_id,
  dateRanges,
  dateGrouping,
  typeGrouping,
  combineSameSku,
  selectedSource,
) => {
  try {
    const queryRoute = "/statistics/compareSales";
    const queryBody = {
      brand_id,
      product_master_id,
      dateRanges,
      dateGrouping,
      typeGrouping,
      combineSameSku,
      selectedSource,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const compareSalesByShop = async (
  brand_id,
  product_master_id,
  dateRanges,
  dateGrouping,
  areaGrouping,
  combineSameSku,
  selectedSource,
) => {
  try {
    const queryRoute = "/statistics/compareSalesByShop";
    const queryBody = {
      brand_id,
      product_master_id,
      dateRanges,
      dateGrouping,
      areaGrouping,
      combineSameSku,
      selectedSource,
    };
    const fetchRes = api.axios.post(queryRoute, queryBody);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
export const getPublicHolidays = async () => {
  try {
    const queryRoute = `https://www.1823.gov.hk/common/ical/tc.json`;

    const result = await api.axios.post(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getEshopSales = async (start_date, end_date) => {
  try {
    const queryRoute = `/eshopStatistics/sales?start_date=${start_date}&end_date=${end_date}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getEshopProductSales = async (date) => {
  try {
    const queryRoute = `/eshopStatistics/sales/products?date=${date}`;
    const fetchRes = api.axios.get(queryRoute);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getPromotionTargetStatistics = async (id, body) => {
  try {
    const queryRoute = `/statistics/promotionTarget/${id}`;
    const fetchRes = api.axios.post(queryRoute, body);
    return (await fetchRes).data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
